module.exports = __webpack_public_path__ + "static/18AprilETE-c4d19cbe4d30c8b32bfec28a3cf521ef.jpeg";